import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const approvalAPI = {
  checkAuth: () => api.get('/approval/check-auth'),
  login: (data) => api.post('/approval/login', data),
  logout: () => api.post('/approval/logout'),

  getCategories: () => api.get('/approval/categories'),
  getAllCategories: () => api.get('/approval/categories/all'),
  createCategory: (data) => api.post('/approval/categories', data),
  updateCategory: (id, data) => api.put(`/approval/categories/${id}`, data),
  toggleCategory: (id) => api.post(`/approval/categories/${id}/toggle`),
  deleteCategory: (id) => api.delete(`/approval/categories/${id}`),

  getUsers: () => api.get('/approval/users'),
  createUser: (data) => api.post('/approval/users', data),
  updateUser: (id, data) => api.put(`/approval/users/${id}`, data),
  activateUser: (id) => api.post(`/approval/users/${id}/activate`),
  deactivateUser: (id) => api.post(`/approval/users/${id}/deactivate`),
  deleteUser: (id) => api.delete(`/approval/users/${id}`),

  getPositions: () => api.get('/approval/positions'),
  createPosition: (data) => api.post('/approval/positions', data),
  updatePosition: (id, data) => api.put(`/approval/positions/${id}`, data),
  deletePosition: (id) => api.delete(`/approval/positions/${id}`),

  getDepartments: () => api.get('/approval/departments'),
  createDepartment: (data) => api.post('/approval/departments', data),
  updateDepartment: (id, data) => api.put(`/approval/departments/${id}`, data),
  deleteDepartment: (id) => api.delete(`/approval/departments/${id}`),

  createRequest: (formData) => api.post('/approval/requests', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getRequests: (params = {}) => api.get('/approval/requests', { params }),
  getRequest: (id) => api.get(`/approval/requests/${id}`),
  addAttachments: (id, formData) => api.post(`/approval/requests/${id}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  takeAction: (id, data) => api.post(`/approval/requests/${id}/action`, data),
  resubmit: (id, formData) => api.post(`/approval/requests/${id}/resubmit`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  cancel: (id) => api.post(`/approval/requests/${id}/cancel`),
  documentUrl: (id) => `${API_BASE_URL}/approval/requests/${id}/document`,

  getStats: () => api.get('/approval/admin/stats'),

  getNotifications: () => api.get('/approval/notifications'),
  markNotificationsRead: () => api.post('/approval/notifications/read'),
};

export default api;
